import { createReducer } from 'redux-act';

import PlaceActivationData from '../../models/form/PlaceActivationData';
import PlaceActivationResult from '../../models/interfaces/PlaceActivationResult';
import * as activatePlace from '../actions/registration/activatePlace';

export interface ActivatePlaceState {
  readonly placeActivationResult: PlaceActivationResult | null;
  readonly placeActivationData: PlaceActivationData | null;
}

const defaultState: ActivatePlaceState = {
  placeActivationResult: null,
  placeActivationData: null,
};

const activatePlaceReducer = createReducer<ActivatePlaceState>({}, defaultState);

activatePlaceReducer.on(activatePlace.placeActivationFinished, (state, { placeActivationResult }) => {
  const { ...others } = state;
  return { ...others, placeActivationResult };
});

activatePlaceReducer.on(activatePlace.placeActivationFailed, (state, { placeActivationResult }) => {
  const { ...others } = state;
  return { ...others, placeActivationResult };
});

activatePlaceReducer.on(activatePlace.activatePlaceFetched, (state, { placeActivationData }) => {
  const { ...others } = state;
  return { ...others, placeActivationData };
});

export default activatePlaceReducer;
